<template>
  <v-row no-gutters>
    <v-col cols="12">
      <field-group
        v-model="dialog.data.name"
        autofocus
        :error-messages="dialog.error.name"
        filled
        label="Tên"
        no-label
      />
    </v-col>

    <v-col cols="12">
      <field-group
        :value="dialog.data.type"
        filled
        label="Loại"
        no-label
        readonly
      />
    </v-col>

    <v-col cols="12">
      <field-group
        :value="meta.srid"
        filled
        label="Hệ tọa độ / SRID"
        no-label
        readonly
      />
    </v-col>

    <v-col cols="12">
      <field-group
        :value="meta.band_count"
        filled
        label="Số lượng band"
        no-label
        readonly
      />
    </v-col>

    <v-col cols="12" class="mb-2">
      <strong>Vùng bao theo hệ tọa độ gốc</strong>
    </v-col>

    <v-col cols="5">
      <field-group :value="bbox.min_x" filled label="Min X" no-label readonly />
    </v-col>
    <v-col cols="2"></v-col>
    <v-col cols="5">
      <field-group :value="bbox.min_y" filled label="Min Y" no-label readonly />
    </v-col>
    <v-col cols="5">
      <field-group :value="bbox.max_x" filled label="Max X" no-label readonly />
    </v-col>
    <v-col cols="2"></v-col>
    <v-col cols="5">
      <field-group :value="bbox.max_y" filled label="Max Y" no-label readonly />
    </v-col>

    <v-col cols="12" class="mt-2 mb-2">
      <strong>Vùng bao Hệ toạ độ 4326</strong>
    </v-col>

    <v-col cols="5">
      <field-group
        :value="wgs84Bbox[0]"
        filled
        label="Min Longitude"
        no-label
        readonly
      />
    </v-col>
    <v-col cols="2"></v-col>
    <v-col cols="5">
      <field-group
        :value="wgs84Bbox[1]"
        filled
        label="Min Latitude"
        no-label
        readonly
      />
    </v-col>
    <v-col cols="5">
      <field-group
        :value="wgs84Bbox[2]"
        filled
        label="Max Longitude"
        no-label
        readonly
      />
    </v-col>
    <v-col cols="2"></v-col>
    <v-col cols="5">
      <field-group
        :value="wgs84Bbox[3]"
        filled
        label="Max Latitude"
        no-label
        readonly
      />
    </v-col>

    <v-col cols="12" class="mt-3" v-if="bands && bands.length > 0">
      <strong>Thông tin band</strong>

      <v-simple-table dense class="mt-2">
        <thead>
          <tr>
            <th>Band</th>
            <th>Kiểu dữ liệu</th>
            <th>Màu</th>
            <th>Mô tả</th>
            <th>NoData</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="band in bands" :key="band.band">
            <td>{{ band.band }}</td>
            <td>{{ band.type }}</td>
            <td>{{ band.color_interpretation }}</td>
            <td>{{ band.description }}</td>
            <td>{{ band.no_data_value }}</td>
          </tr>
        </tbody>
      </v-simple-table>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    dialog: {
      type: Object,
      required: true,
    },
  },
  computed: {
    meta() {
      return this.dialog.data.meta || {}
    },
    bbox() {
      return this.meta.bbox || {}
    },
    wgs84Bbox() {
      return this.meta.bbox_4326 || {}
    },
    bands() {
      return this.meta.bands || []
    },
  },
}
</script>
